import { userRoles } from 'src/services/constants';
import SimpleModel from './SimpleModel';

class CurrentUser extends SimpleModel {
  props() {
    return {
      accountId: null,
      accountKey: null,
      accountRole: null,
      created: null,
      email: null,
      firebase: null,
      groups: [],
      key: null,
    };
  }

  isAllowedToLogin() {
    return this.accountRole && (this.isAdmin() || this.isViewer() || this.isIndividual());
  }

  isAdmin() {
    return this.accountRole === userRoles.ADMIN;
  }

  isViewer() {
    return this.accountRole === userRoles.VIEWER;
  }

  isIndividual() {
    return this.accountRole === userRoles.INDIVIDUAL;
  }

  isDriverWithAccess() {
    return this.isIndividual();
  }
}

export default CurrentUser;
